// extracted by mini-css-extract-plugin
module.exports = {"inputGroup":"Input_inputGroup__5gV2H","disabled":"Input_disabled__n8Jr9","label":"Input_label__Untqv","spin":"Input_spin__wCfI_","loader":"Input_loader__xUbex"};